module.exports = __webpack_public_path__ + "media/funcShow.8cd98911.mp4";